export const CREATE_TEMPLATE = 'CREATE_TEMPLATE'
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE'
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE'
export const SEARCH_TEMPLATE = 'SEARCH_TEMPLATE'
export const SET_TEMPLATE_SEARCH_CRITERIA = 'SET_TEMPLATE_SEARCH_CRITERIA'
export const SET_TEMPLATE_DETAILS = 'SET_TEMPLATE_DETAILS'
export const SET_INIT_CREATE_DETAILS = 'SET_INIT_CREATE_DETAILS'
export const SET_PRINT_ORDER_DETAILS = 'SET_PRINT_ORDER_DETAILS'
